<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <input-area :modelName="modelName" :storeName="storeName" :mutationName="mutationName" :disabled="disabled" />
  </div>
</template>
<script>
import InputArea from './input/input-area.vue'
export default {
  components: { InputArea },
  props: [
    'modelName',
    'label',
    'storeName',
    'mutationName',
    'isRequired',
    'disabled',
  ],
  created() {
  },
}
</script>
